import React, { useState } from 'react';
import { InventoryForm } from "./InventoryForm";
import { InventoryItemCart } from "./InventoryItemCart";
import useInventoryCart from '../Hooks/useInventoryCart';
import Loader from '../../../components/Common/Loader';
import { GeneralAssigment } from '../../../api/Inventory/Entities/InventoryEntities';
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom"
import { ErrorMessage } from '../../../components/Notifications/Notifications';
import { markPendingSuccessNotice } from '../../../components/Notifications/pendingSuccessNotice';
import { useUnsavedChangesPrompt } from '../../../components/Navigation/useUnsavedChangesPrompt';
import InventoryOperationService from '../../../api/Inventory/InventoryOperationService';
import InventoryMedicationService from '../../../api/Inventory/InventoryMedicationService';
import useConfirmationModal from '../../../components/Modals/ConfirmationModal/useConfirmationModal';
import { MoveTypes } from '../../../api/Inventory/Entities/InventoryMovementEntities';
import { MAX_MOVE_ITEM_QUANTITY, isZeroQuantityAllowed } from './inventoryFormRules';
import { InventoryTab, inventoryTabTarget } from '../Pages/inventoryTabNavigation';

import { moveCartActionsStyle, moveCartPanelStyle, moveCartScrollStyle } from './moveCartLayout';
export function InventoryMoveForm({ title, moveId, moveType, assignmentType, onlyLocalInventory = false, useSelecteableRelease = false }) {
    const { t } = useTranslation()
    const history = useHistory();
    const [isWorking, setIsWorking] = useState(false)
    const [move, isLoading, actions] = useInventoryCart(moveId, moveType, assignmentType, null, null, null, { persistDraft: true, history })
    const [Modal, modalActions] = useConfirmationModal();
    const { confirmLeave, allowNavigation } = useUnsavedChangesPrompt(move.items.length > 0, history, actions.DiscardDraft)

    const isAdjust = isZeroQuantityAllowed(moveType)

    if (moveType == undefined)
        throw new Error("MoveType not Assigned")

    function handleNewItem(item) {
        actions.AddItem(item.selectedItem, item.selectedRelease, item.quantity, GeneralAssigment)
    }

    function onDeleteItem(item, _) {
        actions.RemoveItem(item)
    }

    function handleItemChange(quantity, item) {
        actions.UpdateQuantity(item, quantity)
    }

    async function onHandleSubmit() {
        await modalActions.Show({
            title: t('inventory.movements.confirmations.completeTitle'),
            textContent: t('inventory.movements.confirmations.completeTextContent'),
            buttonText: t('buttons.confirm'),
            requireComment: moveType == MoveTypes.AdjustStock.Name,
            onConfirmation: async ({ comment }) => {
                if (isWorking == true) return;
                try {
                    setIsWorking(true)
                    const response = await InventoryOperationService.ExcecuteOperation({
                        ...move,
                        comment: comment
                    })
                    if (response.Succeeded) {
                        markPendingSuccessNotice("commons.successSave")
                        allowNavigation()
                        history.push(inventoryTabTarget(InventoryTab.operations))
                    }
                    else
                        ErrorMessage("errors.serverError")
                } catch (e) {
                    ErrorMessage("errors.serverError")

                } finally {
                    setIsWorking(false)
                }
            }
        })
    }
    async function onHandlePending() {
        await modalActions.Show({
            title: t('inventory.movements.confirmations.completeTitle'),
            textContent: t('inventory.movements.confirmations.completeTextContent'),
            buttonText: t('buttons.confirm'),
            onConfirmation: async () => {
                if (isWorking == true) return;
                try {
                    setIsWorking(true)
                    const response = await InventoryOperationService.SavePending(move)

                    if (response.Succeeded) {
                        markPendingSuccessNotice("commons.successSave")
                        allowNavigation()
                        history.push(inventoryTabTarget(InventoryTab.operations))
                    }
                    else
                        ErrorMessage("errors.serverError")
                } catch (e) {
                    ErrorMessage("errors.serverError")
                } finally {
                    setIsWorking(false)
                }
            }
        })
    }

    function onHandleCancel() {
        if (!confirmLeave()) return
        history.push(inventoryTabTarget(InventoryTab.operations))
    }
    async function onHandleSearchItem(value) {
        const result = await InventoryMedicationService.Find({ term: value, onlyLocal: onlyLocalInventory, pageSize: 100 })
        return result.Value
    }

    return (<>
        <Loader isLoading={isLoading && move != undefined}>
            <div className='max-width-1500 margin-center'>
                <div className='container-fluid form-container' style={{ fontWeight: "bolder" }}>
                    <h5><strong>{title}</strong></h5>
                </div>
                <div className='container-fluid form-container'>
                    <div className='right-side' style={{ height: 'max-content', maxWidth: 'max-content', minWidth: '40rem' }}>
                        <InventoryForm allowZeroQuantity={isAdjust} prefillCurrentStock={isAdjust} handleSubmit={handleNewItem} handleSearchItem={onHandleSearchItem} useSelecteableRelease={useSelecteableRelease} />
                    </div>
                    <div className='left-side' style={moveCartPanelStyle}>
                        <div style={moveCartScrollStyle}>
                            <InventoryItemCart items={move.items} onDeleteItem={onDeleteItem} onItemsChange={handleItemChange} maxQuantity={MAX_MOVE_ITEM_QUANTITY} allowZeroQuantity={isAdjust} />
                        </div>
                        <div style={moveCartActionsStyle}>
                            <button className='btn btn-secondary ml-1' style={{ marginRight: '1rem' }} onClick={onHandleCancel}>{t('buttons.cancel')}</button>
                            <button className='btn btn-warning   ml-1' style={{ marginRight: '1rem' }} disabled={!(move.items.length > 0) || isWorking} onClick={onHandlePending}>{t('buttons.pending')}</button>
                            <button className='btn btn-success' disabled={!(move.items.length > 0) || isWorking} onClick={onHandleSubmit}>{t('buttons.finish')}</button>
                        </div>
                    </div>
                </div>
            </div>
        </Loader>
        <Modal />
    </>)
}